import * as React from 'react';
import * as classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SVG } from '../../../../Utils/SVG';
import './style.css';

export interface VideoActionProps {
  className?: string;
  iconURL?: string;
  isExternal?: boolean;
  label: string;
  linkHref?: string;
  linkTarget?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

export interface VideoActionState {
  /* empty*/
}

export class VideoAction extends React.Component<
  VideoActionProps,
  VideoActionState
> {
  render() {
    const {
      children,
      className,
      iconURL,
      label,
      isExternal = false,
      linkHref = '#',
      linkTarget,
      onClick
    } = this.props;

    const buttonIcon = (
      <span className="video-action-icon-wrapper">
        {iconURL ? <SVG className="video-action-icon" src={iconURL} /> : null}
      </span>
    );

    const buttonLabel = (
      <span className="video-action-label-wrapper">{label}</span>
    );

    return (
      <li className={classNames('video-action', className)}>
        {isExternal ? (
          <a
            className="video-action-link"
            href={linkHref}
            target={linkTarget}
            onClick={onClick}
          >
            {buttonIcon}
            {buttonLabel}
          </a>
        ) : (
          <Link
            className="video-action-link"
            to={linkHref}
            target={linkTarget}
            onClick={onClick}
          >
            {buttonIcon}
            {buttonLabel}
          </Link>
        )}
        {children}
      </li>
    );
  }
}

export default VideoAction;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoDetailsBar/VideoActions/VideoAction/index.tsx